import React from "react";
import { VIEW_ONLY_EMPTY_MESSAGE } from "../../hooks/useAdminPermissions";

const ProductPermissionDenied = ({ message = VIEW_ONLY_EMPTY_MESSAGE, isHtml = false }) => (
  <div
    className={`product-permission-denied ${
      isHtml ? "product-permission-denied--html" : ""
    }`}
  >
    {message}
  </div>
);

export default ProductPermissionDenied;
